"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HomepageFullMarquee;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _panel = require("./panel");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
const HomepageFullMarqueeWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HomepageFullMarqueeWrapper",
  class: "pl-hwsek9t"
});

/**
 * Render HomepageFullMarquee
 *
 * @param {Object} props React props for Homepage Full Marquee
 * @param {object} props.primaryPanel Marquee's Primary Panel
 * @returns {React.ReactElement} Homepage Full Marquee
 * @public
 */
function HomepageFullMarquee({
  primaryPanel,
  partial = ''
}) {
  return /*#__PURE__*/_react.default.createElement(HomepageFullMarqueeWrapper, {
    "data-cy": "full-marquee",
    "data-partial": partial
  }, /*#__PURE__*/_react.default.createElement(_panel.PrimaryPanel, primaryPanel));
}
HomepageFullMarquee.propTypes = {
  primaryPanel: _propTypes.default.shape({
    ..._panel.PrimaryPanel.propTypes
  }).isRequired,
  partial: _propTypes.default.string
};